export default __webpack_public_path__ + "static/media/appstore-games.da9a7203.png";